import { FieldDisplayType } from "@/pages/settings/components/dealsSettings/FieldManagement/types";
import type { DreamerFlow } from "@/pages/settings/components/dealsSettings/StageStudio/workflow/hooks/useAutofillApi";

export enum Month {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAY = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11
}

export enum RevenueModel {
  ARR = "ARR",
  MRR = "MRR"
}

export enum SettingsFieldType {
  SYSTEM = "system",
  CUSTOM = "custom",
  LINKED = "linked",
  HEADER = "header",
  SCO = "sco",
  EDITABLE_SYSTEM = "editableSystem",
  FORMULA = "formula"
}

export enum FieldDataSource {
  SYSTEM = "system",
  MANUAL = "manual",
  HYBRID = "hybrid",
  DREAMER = "dreamer",
  COMPANIES = "companies",
  PEOPLE = "people",
  LEADS = "leads",
  DEALS = "deals",
  DEAL = "deal"
}

export interface LinkedDataInfo {
  targetTable: string;
  sourceKey: string;
  targetKey: string;
  targetField: string;
  targetType: string;
}

// Create identifies the target field by id; the server stores that field's key.
export type CreateLinkedDataInfo = Omit<LinkedDataInfo, "targetField"> & {
  targetFieldId: string;
};

export interface FieldManagementCapabilities {
  canEditDefinition: boolean;
  canDelete: boolean;
  canEditOptions: boolean;
  canHide: boolean;
}

export interface APIFieldItem {
  id: string;
  fieldKey: string;
  label: string;
  displayType: FieldDisplayType;
  fieldType: SettingsFieldType;
  dataSource: FieldDataSource;
  order: number;
  filledByDreamer: boolean;
  dreamerFlow: DreamerFlow | null;
  showInCreation: boolean;
  showInDetailedView: boolean;
  required: boolean;
  config: any | null;
  helpText: string | null;
  section?: string | null;
  isDeleted?: boolean | null;
  isSystem?: boolean;
  hasAutofillConnector?: boolean;
  readOnly?: boolean;
  linkedDataInfo?: LinkedDataInfo;
  fieldManagement?: FieldManagementCapabilities;
}

export interface APIFieldsResponse {
  fields: APIFieldItem[];
}

export interface APIFieldDisplayTypeTargets {
  isPopulated: boolean;
  allowedDisplayTypes: FieldDisplayType[];
}

export interface FieldSection {
  id: string | number;
  name: string;
  order: number;
  entityType?: string;
  createdAt?: string;
}

export interface APIFieldsSectionsResponse {
  fieldsSections: FieldSection[];
}

export enum DealsSettingsTabs {
  GENERAL = "general",
  FIELD_MANAGEMENT = "fieldManagement",
  STAGE_STUDIO = "stageStudio"
}

export enum CompaniesSettingsTabs {
  FIELD_MANAGEMENT = "fieldManagement"
}

export enum PeopleSettingsTabs {
  FIELD_MANAGEMENT = "fieldManagement"
}

export enum LeadSettingsTabs {
  GENERAL = "general",
  FIELD_MANAGEMENT = "fieldManagement"
}

export enum ContractsSettingsTabs {
  GENERAL = "general",
  FIELD_MANAGEMENT = "fieldManagement",
  ONBOARDING_STUDIO = "onboardingStudio"
}

export enum PartnersSettingsTabs {
  GENERAL = "general",
  FIELD_MANAGEMENT = "fieldManagement"
}
